import * as React from 'react';
import { connect } from 'react-redux';
import { toast, ToastOptions } from 'react-toastify';

// Actions
import {
  resendInviteRequest,
  revokeInviteRequest
} from 'src/actions/userInvite';

// Utils
import { pushRoute } from 'src/utils/Navigation';

// Components
import AccountUserInvites from 'src/components/AccountUserInvites';

interface Props {
  accountId: number;
  resendInvite: ({
    inviteId,
    callback
  }: {
    inviteId: number;
    callback: any;
  }) => void;
  revokeInvite: ({
    inviteId,
    callback
  }: {
    inviteId: number;
    callback: any;
  }) => void;
}

class AccountsContainer extends React.Component<Props, any> {
  onInviteClicked = () => {
    const { accountId } = this.props;
    pushRoute(`/accounts/${accountId}/user/invite`);
  };

  onRevokeClicked = (inviteId: number, refetch: () => void) => {
    this.props.revokeInvite({
      callback: refetch,
      inviteId
    });
  };

  onResendClicked = (inviteId: number, refetch: () => void) => {
    this.props.resendInvite({
      callback: refetch,
      inviteId
    });
  };

  onInviteUrlCopy = (inviteUrl: string) => {
    const defaultToastOpts: ToastOptions = {
      position: 'top-center',
      autoClose: 2500,
      hideProgressBar: true
    };

    navigator.clipboard
      .writeText(inviteUrl)
      .then(() => {
        toast('Invitation url has been copied to clipboard.', {
          ...defaultToastOpts,
          type: 'success'
        });
      })
      .catch(() => {
        toast('Failed to copy invitation url to clipboard.', {
          ...defaultToastOpts,
          type: 'error'
        });
      });
  };

  render() {
    const { accountId } = this.props;

    return (
      <AccountUserInvites
        accountId={accountId}
        onInviteClicked={this.onInviteClicked}
        onResendClicked={this.onResendClicked}
        onRevokeClicked={this.onRevokeClicked}
        onInviteUrlCopy={this.onInviteUrlCopy}
      />
    );
  }
}

const mapDispatchToProps = {
  resendInvite: resendInviteRequest,
  revokeInvite: revokeInviteRequest
};

export default connect<Props, any, any>(
  null,
  mapDispatchToProps
)(AccountsContainer);
